import { types, Instance } from 'mobx-state-tree';

const { model, boolean, maybeNull } = types;

export const TierTypeModel = model('TierTypeModel', {
  endUser: maybeNull(boolean),
  group: maybeNull(boolean),
  department: maybeNull(boolean),
  inviteNewUserCreateAccount: maybeNull(boolean),
  inviteNewCurrentUserPasswordUpdate: maybeNull(boolean),
  createEndUserPortal: maybeNull(boolean),
  importCsvLdif: maybeNull(boolean),
  uploadUpdateEndUserAccount: maybeNull(boolean),
  configurePortalWithLdapAuthentication: maybeNull(boolean),
});

export type ITierTypeModel = Instance<typeof TierTypeModel>;
